document.querySelectorAll('.produkt .images').forEach(box => {
	const images = [...box.querySelectorAll('img')]
	const count = images.length
	const show = i => images.forEach((img,n) => img.classList.toggle('active', n <= i))
	if (!count) return
	show(0)
	box.onmousemove = e => {
		const r = box.getBoundingClientRect()
		show(Math.min(count - 1, Math.floor((e.clientX - r.left) / (r.width / count))))
	}
	box.onmouseleave = () => show(0)
})